import { appPackagesStoreV2 } from "@app/static"
import { Log } from "@fanfanlo"

const fileLog = new Log(false, 'AppIcon30');
// fileLog.pause = true;
// fileLog.childrenPaused = true;

export function AppIcon30({packageName}: {packageName:string}){
    const uiLog = fileLog.sub(false, 'AppIcon30_ui')
    // uiLog.pause = true;
    // uiLog.childrenPaused = true;

    const packageInfo = appPackagesStoreV2.findPackageInfoByPackageName(packageName)

    let image = ''
    if (packageInfo && packageInfo.iconBase64) {
        image = 'data:image/gif;base64,' + packageInfo.iconBase64
    } else {
        uiLog.log('no packageInfo or iconBase64, packageName=' + packageName)
    }

    return <img src={image} width={30} style={{ borderRadius: '8px' }} />
}
